import { LoyaltyInfo } from "@redotech/redo-loyalty-common/storefront-popup";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { LoggedInLoyaltyPopup } from "./logged-in-popup";
import { LoggedOutLoyaltyPopup } from "./logged-out-popup";

export const PopupContent = memo(function PopupContent({
  loyaltyInfo,
  redeemPoints,
  undoRedeem,
  className,
}: {
  className?: string;
  loyaltyInfo: LoyaltyInfo;
  redeemPoints: (
    pointsToUse: number,
  ) => Promise<{ discountCode: string; autoApplySuccessful: boolean }>;
  undoRedeem: () => Promise<void>;
}) {
  return (
    <Flex className={className} dir="column" pt="xl">
      {loyaltyInfo.loggedIn ? (
        <LoggedInLoyaltyPopup
          loyaltyInfo={loyaltyInfo}
          readonly={false}
          redeemPoints={redeemPoints}
          undoRedeem={undoRedeem}
        />
      ) : (
        <LoggedOutLoyaltyPopup loyaltyInfo={loyaltyInfo} />
      )}
    </Flex>
  );
});
